import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSupplyDeliveries, SupplyDelivery } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './supplyDeliveriesModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SupplyDelivery> useData={useSupplyDeliveries} config={config} />;
};

export default List;
